import React, { useEffect, useState } from 'react';
import Skeleton from '@mui/material/Skeleton';

const GetYearsOpt = ({ onLoadingChange, onChange }) => {
  const [options, setOptions] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchYears = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_URL_HEADER}/Common/putYears`);
          const data = await response.text();
          setOptions(data);
          setLoading(false); // Stop loading when data is fetched
          onLoadingChange(false); // Notify parent that loading is complete

        } catch (error) {
          console.error("Error fetching commodities:", error);
          setLoading(false);
          onLoadingChange(false); 
        } finally {
          setLoading(false); // Set loading to false after fetching
        }
      };
    fetchYears();
  }, [onLoadingChange]);

  return ( 
    
    <div>
      {loading ? (
        <Skeleton   width={100} height={40} />
      ) : (
    <select name="year" id="year" dangerouslySetInnerHTML={{ __html: options }}  onChange={onChange}  />
  )}
    </div>
    );
};

const getYears = ({ onLoadingChange }) => {
  return (
    <>
      <GetYearsOpt  onLoadingChange={onLoadingChange}/>
    </>
  );
}

export default getYears;
